import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=2d09e79f&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=ts&"
export * from "./audio.vue?vue&type=script&lang=ts&"
import style0 from "./audio.vue?vue&type=style&index=0&id=2d09e79f&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09e79f",
  null
  
)

export default component.exports